var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePayWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 23,
    rx: 3.5,
    stroke: "#DBDADE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5726_7244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.018 8.7785C33.0076 8.7785 33.7724 9.04196 34.3573 9.56888C34.9421 10.0957 35.2119 10.7983 35.2119 11.6764V15.8915H33.9524V14.9257H33.9074C33.3676 15.716 32.6028 16.1112 31.7031 16.1112C30.9383 16.1112 30.2635 15.8916 29.7237 15.4526C29.2288 15.0135 28.9139 14.3988 28.9139 13.7402C28.9139 13.0377 29.1839 12.4668 29.7237 12.0277C30.2635 11.5887 31.0283 11.413 31.928 11.413C32.7377 11.413 33.3676 11.5448 33.8624 11.8521V11.5448C33.8624 11.135 33.7056 10.7252 33.3921 10.4582L33.3225 10.4032C32.9626 10.0958 32.5128 9.92019 32.018 9.92019C31.2532 9.92019 30.6684 10.2276 30.2635 10.8423L29.0939 10.1396C29.8136 9.21751 30.7583 8.7785 32.018 8.7785ZM25.675 5.79272C26.4821 5.79272 27.2493 6.06689 27.8626 6.57817L27.9693 6.67081C28.599 7.19773 28.9139 7.98812 28.9139 8.82235C28.9139 9.65659 28.599 10.403 27.9693 10.9738C27.3394 11.5447 26.5747 11.852 25.675 11.852L23.5157 11.8081V15.8915H22.166V5.79272H25.675ZM32.1979 12.4667C31.6581 12.4667 31.2082 12.5984 30.8483 12.8619C30.4884 13.0814 30.3085 13.3888 30.3085 13.7839C30.3085 14.1352 30.4885 14.4425 30.7583 14.6182C31.0733 14.8378 31.4331 14.9695 31.7931 14.9695C32.2969 14.9695 32.8007 14.7782 33.1948 14.4314L33.2776 14.3548C33.7274 13.9596 33.9524 13.4766 33.9524 12.9497C33.5475 12.6424 32.9626 12.4667 32.1979 12.4667M25.765 7.02205H23.5157V10.5349H25.765C26.2598 10.5349 26.7547 10.3593 27.0696 10.008C27.7893 9.34941 27.7893 8.25171 27.1146 7.59303L27.0696 7.54911C26.7097 7.19787 26.2598 6.97833 25.765 7.02225M42.4997 8.99804L38.0461 18.9651H36.6965L38.361 15.4964L35.4369 9.04196H36.8764L38.9907 14.0035H39.0357L41.1051 9.04196H42.4997V8.99804Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1623 10.9299C18.1623 10.5347 18.1173 10.1395 18.0723 9.74438H12.4492V11.9837H15.6432C15.5082 12.6862 15.1034 13.3448 14.4736 13.74V15.1889H16.408C17.5326 14.1791 18.1624 12.6862 18.1624 10.9299",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4489 16.5942C14.0684 16.5942 15.418 16.0672 16.4077 15.1891L14.4733 13.7402C13.9334 14.0914 13.2587 14.3109 12.4489 14.3109C10.9194 14.3109 9.56978 13.3011 9.11992 11.896H7.14062V13.3888C8.17527 15.3647 10.1996 16.5942 12.4489 16.5942Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12039 11.896C8.85053 11.1934 8.85053 10.4031 9.12039 9.65667V8.16382H7.14109C6.2863 9.78844 6.2863 11.7204 7.14109 13.3888L9.12039 11.896Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4489 7.28559C13.3036 7.28559 14.1134 7.59297 14.7432 8.16375L16.4527 6.49528C15.3729 5.52928 13.9334 4.9585 12.4939 5.00236C10.2446 5.00236 8.17527 6.23182 7.18555 8.20767L9.16491 9.70052C9.56977 8.29544 10.9194 7.28559 12.4489 7.28559Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5726_7244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 14,
    fill: "white",
    transform: "translate(6.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayWalletIcon);
export default __webpack_public_path__ + "static/media/GooglePayWalletIcon.f4a10ff4096c4ca7ecbd72a10f28205f.svg";
export { ForwardRef as ReactComponent };